import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import Alert from '@/storybook/components/Alert/Alert';
import Text from '@/storybook/components/Text/Text';
import styles from './DEAggregatedConsentDisclaimer.module.css';

const DEAggregatedConsentDisclaimer = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'header.DEAggregatedConsentDisclaimer' });

  return (
    <Alert message={t('title')} variant="warning">
      <Text as="p" className={styles.para}>
        {t('paragraphOverview')}
      </Text>
      <Text as="p" className={styles.para}>
        {t('paragraphTeamworkNote')}
      </Text>
      <ul className={cx(styles.disclaimerList)}>
        <li className={cx(styles.para)}>{t('bulletContentByChannel')}</li>
        <li className={cx(styles.para)}>{t('bulletContactInfo')}</li>
      </ul>
    </Alert>
  );
};

export default DEAggregatedConsentDisclaimer;
